import { TextInput } from "@jugl-web/ui-kit";
import { useFormFieldsValidators, useTranslations } from "@jugl-web/utils";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { VoiceGeneralFormValues } from "../../types";

export const WelcomeMessageSection: React.FC = () => {
  const { t } = useTranslations();
  const { requiredValidator } = useFormFieldsValidators();
  const {
    control,
    formState: { errors },
  } = useFormContext<VoiceGeneralFormValues>();

  return (
    <CRMInfoSection
      title={t({
        id: "client-support-page.welcome-message",
        defaultMessage: "Welcome Message",
      })}
      subtitle={t({
        id: "client-support-page.welcome-message-voice-description",
        defaultMessage:
          "AI Agent will always greet customer with indicated welcome message.",
      })}
    >
      <Controller
        control={control}
        name="welcome_message"
        rules={requiredValidator()}
        render={({ field: { value, onChange, ref } }) => (
          <TextInput
            classNames={{ wrapperClassName: "w-full" }}
            ref={ref}
            value={value}
            onChange={(event) => onChange(event.target.value.trimStart())}
            isInvalid={!!errors.welcome_message}
            errorMessage={errors.welcome_message?.message}
            placeholder={t({
              id: "client-support-page.enter-welcome-message",
              defaultMessage: "Enter welcome message",
            })}
          />
        )}
      />
    </CRMInfoSection>
  );
};
